import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface Reward {
    id: number;
    image: string;
    image_url: string;
    title: string;
    description: string;
    link: string;
    credit: string;
    sort: number;
    status: number;
}

export const rewardApi = createApi({
    reducerPath: "rewardApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getRewards: builder.query<Reward[], void>({
            query: () => "/client-reward"
        })
    })
})

export const { useGetRewardsQuery } = rewardApi;